import dayjs from 'dayjs';

import transition from '../../mixins/transition';
import dayjsMixin from '../../mixins/dayjs';

export default {
  name: 'DatePicker',
  mixins: [dayjsMixin, transition],
  model: {
    prop: 'value',
    event: 'change',
  },
  events: ['change', 'selected'],
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
    view: {
      type: String,
      default: 'date',
      validator(value) {
        return ['date', 'month', 'year'].includes(value);
      },
    },
  },
  data() {
    return {
      date: null,
      datePreview: null,
      isSameDate: false,
      dateView: true,
      monthView: false,
      yearView: false,
    };
  },
  watch: {
    value: {
      handler(value) {
        const date = dayjs(value);
        this.date = date.isValid() ? date : dayjs();
        if (!this.datePreview) this.datePreview = this.date;
      },
      immediate: true,
    },
    view: {
      handler(value) {
        switch (value) {
          case 'date':
            this.closeMonthView();
            this.closeYearView();
            this.openDateView();
            break;
          case 'month':
            this.openMonthView();
            break;
          case 'year':
            this.openYearView();
            break;
          default:
            this.closeAllViews();
            break;
        }
      },
      immediate: true,
    },
    date(value, oldValue) {
      this.isSameDate =
        value.isSame(oldValue, 'year') &&
        value.isSame(oldValue, 'month') &&
        value.isSame(oldValue, 'day');

      this.emitEvent('change', value);
    },
    monthView(value) {
      this.$emit('change-view', 'month', value);
    },
    yearView(value) {
      this.$emit('change-view', 'year', value);
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
    selected() {
      this.emitEvent('selected', this.date, false);
    },
    applyDate(value) {
      this.date = value;
      this.datePreview = value;
      this.selected();
      this.closeAllViews();
    },
    applyPreviewDate(value) {
      this.datePreview = value;
    },
    applyMonth(value) {
      this.datePreview = value;
      this.closeMonthView();
    },
    applyYear(value) {
      this.datePreview = value;
      this.closeYearView();
    },
    openDateView() {
      this.dateView = true;
    },
    openMonthView() {
      this.monthView = true;
      this.closeYearView();
    },
    openYearView() {
      this.yearView = true;
      this.closeMonthView();
    },
    closeDateView() {
      this.dateView = false;
    },
    closeMonthView() {
      this.monthView = false;
    },
    closeYearView() {
      this.yearView = false;
    },
    closeAllViews() {
      this.closeYearView();
      this.closeMonthView();
    },
    emitEvent(name, value, checkDate = true, props = this.value) {
      if (typeof props === 'string') {
        this.$emit(name, value.toISOString());
      } else {
        if (checkDate) {
          if (!this.isSameDate) this.$emit(name, value);
        } else {
          this.$emit(name, value);
        }
      }
    },
  },
};
